import { operations } from '»components/templates/TrlInsertOrder/TrlInsertOrderModal/TrlInsertOrderModal.helper.selectors';

export const getOperationLabel = (side) => {
  const operationLabel = operations.find(
    (operation) =>
      operation.value === Number(side) || operation.value === String(side),
  )?.label;

  return operationLabel;
};

export const getOrderTypeLabel = (ordType) => {
  if (ordType === '1' || ordType === '2') return 'TRLT_UI-NORMAL';

  return 'TRLT_UI-STOP';
};
